<template>
    <div>
        <div v-show="isLoading()">
            <div
                class="flex justify-center items-center bg-gray-200 border-t border-b border-gray-400 mb-8"
                role="alert"
            >
                <i class="fal fa-fw fa-spinner fa-spin"></i>
                <span class="text-gray-700 text-sm font-semibold p-2"
                    >Cargando reserva...</span
                >
            </div>
        </div>

        <div class="mb-6" v-show="errors.response">
            <div
                class="m-auto max-w-md bg-orange-100 border-t-4 border-orange-500 rounded-b text-orange-900 px-4 py-3"
                role="alert"
            >
                <div class="flex">
                    <div class="py-1">
                        <svg
                            class="fill-current h-6 w-6 text-orange-500 mr-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                        >
                            <path
                                d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
                            />
                        </svg>
                    </div>
                    <div>
                        <p class="font-bold">
                            No pudimos encontrar la reserva solicitda.
                        </p>
                        <p class="text-sm">{{ errors.response }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="reserva">
            <div class="flex flex-col mb-8">
                <div class="flex flex-wrap items-start">
                    <h3 class="yamaha-subtitle font-light text-red mr-2">
                        Reserva <i class="fal fa-hashtag"></i> {{ reserva.id }}
                    </h3>
                </div>
            </div>

            <div class="flex flex-wrap">
                <!-- Cuándo -->
                <div
                    class="flex flex-col w-full border-t border-gray-400 lg:w-1/4 mb-4 pr-0 lg:pr-2"
                >
                    <div class="bg-gray-100 border-b border-gray-400 py-2 px-2">
                        <p class="uppercase text-sm font-light text-gray-800">
                            Cuándo
                        </p>
                    </div>
                    <div
                        class="p-4 flex flex-col leading-normal text-gray-800 print:items-center"
                    >
                        <!-- Calendario -->
                        <div
                            class="min-w-32 bg-white min-h-48 p-3 mb-4 font-medium m-auto"
                        >
                            <div
                                class="w-32 flex-none rounded-t lg:rounded-t-none lg:rounded-l text-center shadow "
                            >
                                <div
                                    class="block rounded-t overflow-hidden text-center "
                                >
                                    <div
                                        class="bg-blue-600 text-white py-1 uppercase"
                                    >
                                        {{
                                            reserva.fecha_inicio
                                                | formatDate("MMMM")
                                        }}
                                    </div>
                                    <div
                                        class="pt-1 border-l border-r border-white bg-white"
                                    >
                                        <span
                                            class="text-5xl font-bold leading-tight"
                                            >{{
                                                reserva.fecha_inicio
                                                    | formatDate("DD")
                                            }}</span
                                        >
                                    </div>
                                    <div
                                        class="border-l border-r border-b rounded-b-lg text-center border-white bg-white -pt-2 -mb-1"
                                    >
                                        <span class="text-sm">
                                            {{
                                                reserva.fecha_inicio
                                                    | formatDate("dddd")
                                            }}
                                        </span>
                                    </div>
                                    <div
                                        class="pb-2 border-l border-r border-b rounded-b-lg text-center border-white bg-white"
                                    >
                                        <span class="text-xs leading-normal">
                                            {{
                                                reserva.fecha_inicio
                                                    | formatDate(
                                                        "HH:mm",
                                                        " hrs"
                                                    )
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Dirección -->
                        <div
                            class="text-sm font-semibold text-gray-700 print:text-center"
                        >
                            {{
                                reserva.distribuidor
                                    ? reserva.distribuidor.nombre
                                    : ""
                            }}
                        </div>
                        <div class="mt-1 text-sm font-light">
                            {{
                                reserva.distribuidor
                                    ? reserva.distribuidor.direccion
                                    : "-"
                            }}
                            <span class="block">
                                {{
                                    reserva.distribuidor
                                        ? reserva.distribuidor.ciudad +
                                          (reserva.region.id === 13
                                              ? ", Santiago"
                                              : ", " + reserva.region.nombre)
                                        : ""
                                }}
                            </span>
                        </div>
                        <button
                            @click="abrirModal('modalMapa')"
                            class="w-full md:w-auto border border-blue-600 text-blue-600 hover:border-blue-600 hover:bg-blue-600 hover:text-white uppercase py-3 px-5 mt-4 mb-4 focus:outline-none focus:shadow-outline print:hidden"
                        >
                            <!--i class="fal fa-fw fa-map"></i-->
                            Ver mapa
                        </button>
                        <button
                            @click="imprimirReserva"
                            class="w-full md:w-auto border border-blue-600 text-blue-600 hover:border-blue-600 hover:bg-blue-600 hover:text-white uppercase py-3 px-5 mt-1 mb-4 focus:outline-none focus:shadow-outline print:hidden"
                        >
                            <!--i class="fal fa-fw fa-map"></i-->
                            Imprimir Reserva
                        </button>
                        <button
                            v-show="reserva !== null && !esCerrada"
                            @click.prevent="abrirModal('modalAnular')"
                            class="text-sm w-full md:w-auto text-red-500 hover:text-white hover:bg-red-500 text-white uppercase py-2 px-2 mb-4 focus:outline-none focus:shadow-outline print:hidden"
                        >
                            <i class="fal fa-fw fa-times"></i> Anular reserva
                        </button>
                    </div>
                </div>
                <!-- Moto, Cliente y Servicios -->
                <div class="flex flex-col flex-wrap w-full lg:w-3/4">
                    <!-- Servicios -->
                    <div
                        class="flex flex-col w-full lg:flex-1 border-t border-gray-400 mr-0 mb-4"
                    >
                        <div
                            class="flex flex-wrap justify-between bg-gray-100 border-b border-gray-400 py-2 px-2"
                        >
                            <div
                                class="uppercase text-sm font-light text-gray-800"
                            >
                                Servicio solicitado
                            </div>
                            <div class="text-sm font-light text-gray-800">
                                <!--
                                <span v-show="!esPresupuesto">
                                    Duración estimada:
                                    <span class="font-bold"
                                        >{{ reserva.duracion_total }} h</span
                                    >
                                </span>
                                / -->
                                Total:
                                <span class="font-bold"
                                    >${{ reserva.valor_total | prettyNumber }}
                                    <small>IVA incl.</small></span
                                >
                            </div>
                        </div>
                        <div class="px-4 pt-4 flex">
                            <ul class="list-reset leading-normal text-gray-800">
                                <li
                                    v-for="servicio in reserva.servicios"
                                    :key="servicio.id"
                                >
                                    <pretty-check
                                        class="leading-tight p-default p-smooth p-locked"
                                        color="info"
                                        checked="true"
                                    >
                                        <span class="text-sm">{{
                                            servicio.nombre
                                        }}</span>
                                    </pretty-check>
                                </li>
                            </ul>
                        </div>
                        <div
                            class="px-4 py-4 w-full text-xs text-gray-700"
                            v-if="reserva.servicios.length > 0"
                        >
                            <ul
                                class="flex flex-col md:flex-row flex-wrap list-disc pl-4"
                            >
                                <li
                                    class="pr-4 mr-2"
                                    v-for="(incluye, index) in listaIncluye"
                                    :key="index"
                                >
                                    {{ incluye }}
                                </li>
                            </ul>
                        </div>
                        <!--div
                            class="px-4 pb-4 w-full text-sm text-gray-700 font-semibold"
                        >
                            Asesor de servicio:
                            {{ reserva.asesor ? reserva.asesor.name : "" }}
                        </div-->
                        <div class="my-4">
                            <div
                                class="m-auto w-full bg-orange-100 border-t-4 border-orange-500 rounded-b text-orange-900 px-4 py-3"
                                role="alert"
                            >
                                <div class="flex">
                                    <div class="py-1">
                                        <svg
                                            class="fill-current h-6 w-6 text-orange-500 mr-4"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
                                            />
                                        </svg>
                                    </div>
                                    <div>
                                        <p class="font-bold">
                                            Importante
                                        </p>
                                        <p class="text-sm">
                                            El horario de entrega queda sujeto a
                                            disponibilidad y se coordinará con
                                            el asesor de servicio.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Datos de la Moto y del Cliente -->
                    <div class="flex flex-wrap mb-4 mr-0 lg:mr-2 print:-mr-2">
                        <!-- Datos de la Moto -->
                        <div
                            class="flex flex-col w-full lg:flex-1 border-t border-gray-400 mr-0 mb-4 lg:mr-2 print:mr-2 print:flex-1"
                        >
                            <div
                                class="bg-gray-100 border-b border-gray-400 py-2 px-2"
                            >
                                <p
                                    class="uppercase text-sm font-light text-gray-800"
                                >
                                    Datos de la moto
                                </p>
                            </div>
                            <div class="px-4 pt-4 flex">
                                <div
                                    class="flex flex-col leading-normal text-gray-800"
                                >
                                    <div
                                        class="text-lg font-semibold text-gray-700"
                                    >
                                        {{ reserva.moto.modelo }}
                                    </div>
                                    <div class="mb-1 text-sm font-light">
                                        <i
                                            class="fal fa-motorcycle fa-fw text-gray-600"
                                        ></i>
                                        Patente {{ reserva.patente }}
                                    </div>
                                    <div class="mb-1 text-sm font-light">
                                        <i
                                            class="fal fa-barcode-alt fa-fw text-gray-600"
                                        ></i>
                                        Chasis Nº {{ reserva.chasis }}
                                    </div>
                                    <div class="mb-1 text-sm font-light">
                                        <i
                                            class="fal fa-tag fa-fw text-gray-600"
                                        ></i>
                                        Año {{ reserva.anio }}
                                    </div>
                                    <div class="mb-1 text-sm font-light">
                                        <i
                                            class="fal fa-tachometer-alt-fast fa-fw text-gray-600"
                                        ></i>
                                        Kilometraje
                                        {{ reserva.kilometraje | prettyNumber }}
                                    </div>
                                    <div
                                        class="mb-1 text-sm font-light"
                                        v-if="
                                            reserva.extra &&
                                                reserva.extra.comentarios &&
                                                reserva.extra.comentarios
                                                    .length > 0
                                        "
                                    >
                                        <i
                                            class="fal fa-comments fa-fw text-gray-600"
                                        ></i>
                                        {{ reserva.extra.comentarios || "" }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Datos del Cliente -->
                        <div
                            class="flex flex-col w-full lg:flex-1 border-t border-gray-400 mr-0 mb-4 print:ml-2 print:flex-1"
                        >
                            <div
                                class="bg-gray-100 border-b border-gray-400 py-2 px-2"
                            >
                                <p
                                    class="uppercase text-sm font-light text-gray-800"
                                >
                                    Datos del cliente
                                </p>
                            </div>
                            <div
                                class="p-4 flex flex-col leading-normal text-gray-800"
                            >
                                <div
                                    class="text-lg font-semibold text-gray-700"
                                >
                                    {{
                                        reserva.nombre + " " + reserva.apellido
                                    }}
                                </div>
                                <div class="mt-1 text-sm font-light">
                                    <i
                                        class="fal fa-id-card fa-fw text-gray-600"
                                    ></i>
                                    {{ reserva.rut }}
                                </div>
                                <div class="mt-1 text-sm font-light">
                                    <i
                                        class="fal fa-at fa-fw text-gray-600"
                                    ></i>
                                    {{ reserva.email }}
                                </div>
                                <span class="mt-1 text-sm font-light">
                                    <i
                                        class="fal fa-map-marked-alt fa-fw text-gray-600"
                                    ></i>
                                    {{
                                        reserva.direccion +
                                            ", " +
                                            (reserva.comuna
                                                ? reserva.comuna.nombre
                                                : "")
                                    }}
                                </span>
                                <span class="mt-1 text-sm font-light">
                                    <i
                                        class="fal fa-phone fa-fw text-gray-600"
                                    ></i>
                                    {{ reserva.telefono }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <sweet-modal ref="modalMapa">
            <div v-if="reserva" v-html="iframeHtml"></div>
        </sweet-modal>

        <sweet-modal
            v-if="reserva"
            ref="modalAnular"
            icon="warning"
            :title="'Anular reserva ' + reserva.id"
        >
            <p class="font-semibold">
                ¿Está seguro que desea anular su reserva?
            </p>
            <p>La acción no podrá ser revertida.</p>

            <button
                slot="button"
                @click.prevent="cerrarModal('modalAnular')"
                class="uppercase bg-white hover:bg-gray-100 text-gray-800 font-semibold mr-2 py-2 px-4 border border-gray-400"
            >
                Cancelar
            </button>
            <button
                slot="button"
                @click="anularReserva"
                class="uppercase bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4"
            >
                Anular
            </button>
        </sweet-modal>
    </div>
</template>

<script>
import YamahaApi from "../Api";
import Loader from "./mixins/Loader";
import Utilities from "../utilities";
import { SweetModal } from "sweet-modal-vue";
import PrettyCheck from "pretty-checkbox-vue/check";

export default {
    name: "DetalleReserva",
    components: { SweetModal, PrettyCheck },
    mixins: [Loader],
    computed: {
        rutDv() {
            return (
                this.reserva.rut + "-" + Utilities.calcularDv(this.reserva.rut)
            );
        },
        iframeHtml() {
            return this.reserva.distribuidor.link_mapa.replace(/\\"/gi, "");
        },
        listaIncluye() {
            let incluye = [];

            this.reserva.servicios.forEach(s => {
                if (s.detalle.incluye) {
                    incluye = incluye.concat(s.detalle.incluye.split("\n"));
                }
            });

            return incluye.filter(
                (value, index, list) => list.indexOf(value) === index
            );
        },
        esCerrada() {
            if (this.reserva) {
                return this.reserva.estado === 2 || this.reserva.estado === 4;
            }

            return false;
        }
    },
    data() {
        return {
            Api: null,
            reserva: null,
            esPresupuesto: false,
            errors: { response: null }
        };
    },
    methods: {
        abrirModal(ref) {
            if (this.$refs[ref]) {
                this.$refs[ref].open();
            }
        },
        imprimirReserva() {
            window.print();
        },
        cerrarModal(ref) {
            if (this.$refs[ref]) {
                this.$refs[ref].close();
            }
        },
        obtenerReserva() {
            this.load();

            this.Api.instance
                .request({
                    url:
                        this.Api.endpointPrefix +
                        "/agendamiento/reserva/" +
                        this.$route.params.id,
                    method: "get"
                })
                .then(response => {
                    if (response.data && response.data.id) {
                        this.reserva = response.data;

                        this.esPresupuesto =
                            this.reserva.servicios[0].tipo === "PRESUPUESTO";
                    } else {
                        this.errors.response =
                            "Lo sentimos, pero no pudimos encontrar ninguna reserva asociada al código proporcionado.";
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.errors.response = `En estos momentos no podemos atender tu solicitud (Código YHA-${
                            error.response.status
                        })`;
                    }
                })
                .then(() => {
                    this.loadComplete();
                });
        },
        anularReserva() {
            this.load();

            this.Api.instance
                .request({
                    url:
                        this.Api.endpointPrefix +
                        "/agendamiento/reserva/" +
                        this.$route.params.id,
                    method: "delete"
                })
                .then(response => {
                    if (response.data.destroyed) {
                        alert("Su reserva ha sido anulada");
                        this.$router.push({ name: "home" });
                    } else {
                        this.errors.response =
                            "Lo sentimos, pero en estos momentos no podemos anular su reserva.";
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.errors.response = `En estos momentos no podemos atender su solicitud (Código YHA-${
                            error.response.status
                        })`;
                    }
                })
                .then(() => {
                    this.loadComplete();
                });
        }
    },
    created() {
        this.Api = new YamahaApi("BO");
        this.obtenerReserva();
    }
};
</script>
